/**
 * Pure decision for what the auth gate should render, factoring in the iPad
 * offline cache. Kept separate from AuthWrapper so the matrix is unit-testable.
 */
export type OfflineUserResolution<U> =
  | { kind: "user"; user: U }
  | { kind: "login" }
  | { kind: "offline-first-launch" };

export function resolveOfflineUser<U>(args: {
  /** Live user from the server query, if it resolved. */
  user: U | null | undefined;
  /** Cached user from a previous online session (iPad only). */
  cachedUser: U | null;
  /** True when running in the iPad Capacitor shell without connectivity. */
  iPadOffline: boolean;
}): OfflineUserResolution<U> {
  if (args.user) {
    return { kind: "user", user: args.user };
  }

  if (args.iPadOffline && args.cachedUser) {
    return { kind: "user", user: args.cachedUser };
  }

  if (args.iPadOffline) {
    // Offline on the iPad but never authenticated on this device — can't sign
    // in for the first time without a network round-trip.
    return { kind: "offline-first-launch" };
  }

  return { kind: "login" };
}
